export default {"src":"/_next/static/media/back.d212b964.svg","height":16,"width":16};